import React from "react";
import classNames from "classnames";
import { Button, ButtonProps } from "antd";
import styles from "./InfyButton.module.scss";

export interface InfyButtonProps extends ButtonProps {
  containerClass?: string;
  bicolor?: "primary" | "secondary" | "tertiary" | "success";
  suffixIcon?: React.ReactNode;
  width?: string;
}

const InfyButton: React.FC<InfyButtonProps> = ({ width, children, containerClass, bicolor = null, suffixIcon = null, ...props }) => (
  <div
    className={classNames(
      classNames(containerClass, styles.container, {
        [styles[bicolor]]: bicolor
      })
    )}
  >
    <Button {...props} style={{ ...props.style, width }}>
      {children}
      {suffixIcon}
    </Button>
  </div>
);

export default InfyButton;
